import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => { };

export const CUSTOM_TEXTAREA_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FormTextareaComponent),
	multi: true
};
@Component({
	selector: 'fm-textarea',
	templateUrl: 'form-textarea.component.html',
	styles: [
		`
		.fm-textarea {
			height: 75px;
			width: 100%;
		}

		textarea.fm-textarea:disabled {
			background-color: white;
			opacity: .35;
		}
		`
	],
	providers: [CUSTOM_TEXTAREA_CONTROL_VALUE_ACCESSOR]
})
export class FormTextareaComponent extends BaseErrorForm
	implements ControlValueAccessor, OnInit, OnDestroy {
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		public formEventService: FormEventService
	) {
		super();
	}

	tabindex: string;
	@Input('tabindex')
	set tabind(val: string) {
		this.tabindex = String(val);
	}

	@Input() cols: number;
	@Input() rows: number = 4;
	@Input() autoResize: boolean = true;
	@Input() readonly: boolean = false;
	@Input() disabled: boolean = false;

	@Output() onChanged: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('in') input: ElementRef;

	private numOfTabs: number = 0;
	private innerValue: any = '';

	// Placeholders for the callbacks which are later provided
	// by the Control Value Accessor
	private onTouchedCallback: () => void = noop;
	private onChangeCallback: (_: any) => void = noop;

	ngOnInit() {
		this.formEventService.setIndex(parseInt(this.tabindex));

		const elem: HTMLElement = this.el.nativeElement;
		this.renderer.setStyle(elem, 'outline', 'none');
	}

	ngOnDestroy() { }

	get value(): any {
		return this.innerValue;
	}

	// set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.onChangeCallback(v);
		}
	}

	//Set touched on blur
	onBlur() {
		this.onTouchedCallback();
	}

	// From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	// From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	// From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

	onChange(newValue: string) {
		if (newValue !== this.innerValue) {
			this.writeValue(newValue);
		}
		this.onChanged.emit(newValue);
	}
}
